import { render, staticRenderFns } from "./Mms.vue?vue&type=template&id=0226a58f&"
import script from "./Mms.vue?vue&type=script&lang=js&"
export * from "./Mms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports